import { RateObject, Ratio } from '../ImageElement.types';

export const isRatioObject = (value: Ratio): value is RateObject => {
  if (typeof value === 'object' && 'mobile' in value) {
    return true;
  }
  return false;
};
